import React from 'react';
import PropTypes from 'prop-types';
import { EVENT_MEDIA_STATUS } from './eventMediaConstants';

export default class EventMediaVideo extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.previewVideoUrl) {
            return null;
        }

        if (this.props.status === EVENT_MEDIA_STATUS.ERROR_PLAYBACK_FAILED) {
            return null;
        }
        
        let preload = "metadata" /* allows autoplay on iOS chrome safari etc */
        let autoPlay = true;
        if (this.props.autoPlay !== undefined) {
            autoPlay = this.props.autoPlay;
            if (autoPlay === false) {
                preload = "none";
            }
        }
        return (
            <video
                id={this.props.id}
                className="event-video-preview"
                autoPlay={autoPlay}
                loop
                muted /* allows autoplay on chrome and Android mobile, and modern desktop browsers */
                playsInline /* allows autoplay on iOS chrome safari etc */
                preload={preload}
                src={this.props.previewVideoUrl}
                onClick={this.props.onClick}
                onError={this.props.onError}
                onCanPlay={this.props.onCanPlay}>
            </video>
        )
    }
}

EventMediaVideo.propTypes = {
    previewVideoUrl: PropTypes.string, /* optional, if available */
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    onCanPlay: PropTypes.func.isRequired,
    autoPlay: PropTypes.bool, /* defaults to true, used by cluster component to avoid loading all videos int he cluster */
    status: PropTypes.string.isRequired
};
